<template>
  <div class="subscribe-to-availability">
    <DefButtonSecondary @click="handlerOpenModal">
      {{ messages.informAvailability }}
    </DefButtonSecondary>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import ProductSubscribeForm from '@components/Product/ProductSubscribe/ProductSubscribeForm.vue';
import useModal from '@use/useModal/useModal';

export default {
  name: 'SubscribeToAvailability',
  components: { DefButtonSecondary },
  data() {
    return {
      modal: useModal(),
    };
  },
  methods: {
    handlerOpenModal() {
      this.modal.show(ProductSubscribeForm, {}, { width: '328px', widthTablet: '400px' });
    },
  },
  computed: {
    ...mapState({
      messages: ({ product }) => product.data.messages,
    }),
  },
};
</script>

<style lang="scss" scoped>
.subscribe-to-availability {
  :deep(.def-button-secondary) {
    width: 100%;
    margin-top: 16px;
  }
}
</style>
